var _defs, _circle, _path, _path2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHandtruckicon24Px = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 22.53 19.7",
    width: "24px",
    height: "24px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.75px;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.36,
    cy: 17.21,
    r: 2.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.86,17.46a3.11,3.11,0,0,1,.49-.16L6.7,3.7a.51.51,0,0,0-.46-.31l-5-.16a.52.52,0,0,0,0,1l4.63.14L11.4,17.7A3.33,3.33,0,0,1,11.86,17.46Z",
    transform: "translate(-0.74 -3.23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.17,16.25A.52.52,0,0,0,22.5,16l-6.66,2.77a3.33,3.33,0,0,1,.24.46,3.11,3.11,0,0,1,.16.49l6.65-2.76A.51.51,0,0,0,23.17,16.25Z",
    transform: "translate(-0.74 -3.23)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.58,
    y: 5.54,
    width: 7.86,
    height: 5.86,
    rx: 0.34,
    transform: "translate(-2.95 2.6) rotate(-22.58)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.24,14.79,21,9.44a.34.34,0,0,0-.45-.18l-9,3.76a.34.34,0,0,0-.19.45l1.56,3.75a3.21,3.21,0,0,1,2.68,1.14l7.48-3.12A.34.34,0,0,0,23.24,14.79Z",
    transform: "translate(-0.74 -3.23)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHandtruckicon24Px, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Handtruck icon 24px.ba02c347.svg";
export { ForwardRef as ReactComponent };